import React from 'react';
import { AcceptBlock, inputBlock, LangBlock, ShowNotify } from '../../global';
import { SystemShared } from '../../../../shared/system';
import { PRODUCTS_LIST } from '../../../../shared/products';
import { ADMIN_GIVE_REWARD_REASON_LIST } from '../../../../shared/admin';
import { WebStorage } from '../../../storage';
import type { GiveRewardState } from './useAdminData';
import {
    AdminButton,
    AdminFormField,
    AdminFormGrid,
    AdminPageWrap,
    AdminSection,
} from './admin.ui';

export const AdminRewards = () => {
    const [, , LangString] = LangBlock();

    const [giveReward, setGiveReward] = React.useState<GiveRewardState>({
        product: 'application',
        days: 1,
        reason: 0,
    });

    return (
        <AdminPageWrap>
            <AdminSection
                title={LangString('AdminRewardsTitle')}
                subtitle={LangString('AdminRewardsSubtitle')}
            >
                <AdminFormGrid>
                    <AdminFormField label={LangString('AdminDays')}>
                        {inputBlock(
                            'number',
                            giveReward.days,
                            (val) => setGiveReward((old) => ({ ...old, days: val })),
                            LangString('AdminDays'),
                        )}
                    </AdminFormField>
                    <AdminFormField label={LangString('AdminProduct')}>
                        {inputBlock(
                            'select',
                            giveReward.product,
                            (val) => setGiveReward((old) => ({ ...old, product: val })),
                            PRODUCTS_LIST.map((q) => ({
                                label: LangString(q.name),
                                value: q.type,
                            })),
                        )}
                    </AdminFormField>
                    <AdminFormField label={LangString('AdminRewardReason')}>
                        {inputBlock(
                            'select',
                            giveReward.reason,
                            (val) => setGiveReward((old) => ({ ...old, reason: val })),
                            ADMIN_GIVE_REWARD_REASON_LIST.map((_q, i) => ({
                                label: LangString('AdminRewardReasonCompensation'),
                                value: i,
                            })),
                        )}
                    </AdminFormField>
                </AdminFormGrid>

                <AdminButton
                    variant="primary"
                    block
                    onClick={async (e) => {
                        e.preventDefault();

                        if (!(await AcceptBlock())) {
                            return;
                        }

                        WebStorage.ApiRequestPost('/api/admin/multireward/give', {
                            record: SystemShared.toBinary(JSON.stringify(giveReward)),
                        }).then((res) => {
                            if (res.status) {
                                ShowNotify(LangString('AdminGiveReward'), LangString('AdminSuccess'), 'success');
                            } else {
                                ShowNotify(LangString('AdminGiveReward'), res.error_message, 'error');
                            }
                        });
                    }}
                >
                    {LangString('AdminGiveReward')}
                </AdminButton>
            </AdminSection>
        </AdminPageWrap>
    );
};
